import React, { useState, useEffect } from "react";
import axios from "axios";
import ConfirmationModal from "./ConfirmationModal";
import CustomerDetails from "./CustomerDetails";
import ProductTable from "./ProductTable";
import LoadingScreen from "../Loading_Screen/LoadingScreen";
import Modal from "./Modal";
import API_BASE_URL from "../../ApiConfig/ApiConfig";
import Cookies from "js-cookie";

import "@fortawesome/fontawesome-free/css/all.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import Search from "../../../Assets/Icon search.svg";

const AdminViewWarrantyExtended = () => {
  const [warranties, setWarranties] = useState([]);

  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [selectedCustomerDetails, setSelectedCustomerDetails] = useState(null);
  const [selectedCustomerRecords, setSelectedCustomerRecords] = useState([]);
  const [selectedProductIds, setSelectedProductIds] = useState([]);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [statusCheckMessage, setStatusCheckMessage] = useState("");
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // State for search input


  // Fetch warranties data
  const getFirstLetter = (name) => {
    return name.charAt(0).toUpperCase();
  };
  const token = Cookies.get("admin");
  const fetchWarranties = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/warranty/fetch`,
        { headers: { "Content-Type": "application/json" ,
          "Authorization":token ? `Bearer ${token}` : "",
        } }
      );
      const fetchedWarranties = response.data;
  
      // Ensure warranties are set properly
      setWarranties(fetchedWarranties || []); // Use an empty array as a fallback
    } catch (error) {
      console.error("Error fetching warranties:", error);
      setWarranties([]); // Set to empty array on error to avoid breaking the UI
    }
  };
  
  useEffect(() => {
    fetchWarranties();
  }, []);

  useEffect(() => {
    if (selectedCustomerId) {
      const fetchCustomerDetails = async () => {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/users/customer/${selectedCustomerId}`,
            { headers: { "Content-Type": "application/json" ,
              "Authorization":token ? `Bearer ${token}` : "",
            } }
          );
          setSelectedCustomerDetails(response.data);
        } catch (error) {
          console.error("Error fetching customer details:", error);
        }
      };

      const fetchCustomerRecords = async () => {
        try {
          const response = await axios.get(
            `${API_BASE_URL}/api/warranty/customerid/${selectedCustomerId}`,
            { headers: { "Content-Type": "application/json" ,
              "Authorization":token ? `Bearer ${token}` : "",
            } }
          );
          setSelectedCustomerRecords(response.data);
        } catch (error) {
          console.error("Error fetching customer records:", error);
        }
      };

      fetchCustomerDetails();
      fetchCustomerRecords();
    }
  }, [selectedCustomerId]);

  const handleView = (customerId) => {
    setSelectedCustomerId(customerId);
    setIsDetailsModalOpen(true);
  };

  const handleApprove = async (productId) => {
    const selectedProduct = selectedCustomerRecords.find(
      (record) => record._id === productId
    );

    if (selectedProduct && checkStatus(selectedProduct.status)) {
      setShowApproveModal(true); // Open modal for confirmation
      setSelectedProductIds([productId]); // Track the selected product
      setStatusCheckMessage(""); // Reset status check message
    }
  };

  const handleReject = async (productId) => {
    const selectedProduct = selectedCustomerRecords.find(
      (record) => record._id === productId
    );

    if (selectedProduct && checkStatus(selectedProduct.status)) {
      setShowRejectModal(true); // Open modal for confirmation
      setSelectedProductIds([productId]); // Track the selected product
      setStatusCheckMessage(""); // Reset status check message
    }
  };

  const checkStatus = (status) => {
    if (status === "Approved" || status === "Rejected") {
      setStatusCheckMessage(`Action already taken: ${status}`);
      return false;
    }
    return true;
  };

  const confirmApprove = async (file) => {
    setIsLoading(true);
    try {
      const formData = new FormData();
      formData.append("pdf", file);
      formData.append("productIds", JSON.stringify(selectedProductIds));
      formData.append("newStatus", "Approved");

      await axios.post(`${API_BASE_URL}/api/warranty/approve`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        "Authorization":token ? `Bearer ${token}` : "",
      });

      const newExpiryDate = new Date();
      newExpiryDate.setMonth(newExpiryDate.getMonth() + 3);

      const updatedRecords = selectedCustomerRecords.map((record) =>
        selectedProductIds.includes(record._id)
          ? {
              ...record,
              status: "Approved",
              expiryDate: newExpiryDate.toISOString(),
            }
          : record
      );
      setSelectedCustomerRecords(updatedRecords);

      setShowApproveModal(false);
      fetchWarranties();

      const response = await axios.get(
        `${API_BASE_URL}/api/warranty/customerid/${selectedCustomerId}`,
        { headers: { "Content-Type": "application/json" ,
          "Authorization":token ? `Bearer ${token}` : "",
        } }
      );
      setSelectedCustomerRecords(response.data);
    } catch (error) {
      console.error("Error approving products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const confirmReject = async () => {
    setIsLoading(true);
    try {
      await axios.post(`${API_BASE_URL}/api/warranty/reject`, {
        productIds: selectedProductIds,
        newStatus: "Rejected",
      },
      { headers: { "Content-Type": "application/json" ,
        "Authorization":token ? `Bearer ${token}` : "",
      } });

      const updatedRecords = selectedCustomerRecords.map((record) =>
        selectedProductIds.includes(record._id)
          ? { ...record, status: "Rejected" }
          : record
      );
      setSelectedCustomerRecords(updatedRecords);

      setShowRejectModal(false);
      fetchWarranties();
    } catch (error) {
      console.error("Error rejecting products:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const cancelApprove = () => {
    setShowApproveModal(false);
  };

  const cancelReject = () => setShowRejectModal(false);

  const viewInvoice = (invoicePath) => {
    window.open(
      `${API_BASE_URL}${invoicePath}`,
      "_blank",
      "noopener,noreferrer"
    );
  };



  const getUniqueCustomers = (warranties) => {
    const uniqueCustomerMap = new Map();
    warranties.forEach((warranty) => {
      if (!uniqueCustomerMap.has(warranty.customerId)) {
        uniqueCustomerMap.set(warranty.customerId, warranty);
      }
    });
    return Array.from(uniqueCustomerMap.values());
  };

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Adjust items per page as needed

  useEffect(() => {
    fetchWarranties();
  }, []);

  const uniqueCustomers = getUniqueCustomers(warranties);

  // Filter customers based on search term
  const filteredCustomers = uniqueCustomers.filter(
    (customer) =>
      customer.customerId.includes(searchTerm) ||
      customer.customerName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination calculation
  const totalPages = Math.ceil(filteredCustomers.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentCustomers = filteredCustomers.slice(startIndex, endIndex);

  // Pagination handlers
  const goToPreviousPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const goToNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
  
    <div className="p-6 min-h-screen">
    {isLoading && <LoadingScreen />}
    <div className="flex flex-col sm:flex-row sm:justify-between items-center mb-8">
  <h1 className="text-3xl font-bold text-gray-800 mb-4 sm:mb-0">Warranty Requests</h1>
  <div className="relative w-full sm:w-1/3">
    <input
      type="text"
      placeholder="Search by Customer ID/Name"
      value={searchTerm}
      onChange={(e) => setSearchTerm(e.target.value)}
      className="p-2 pl-10 pr-3 rounded-lg w-full border border-gray-300 shadow-sm outline-none focus:ring-1 focus:ring-gray-300 focus:border-gray-300"
    />
    <img
      src={Search}
      alt="Search Icon"
      className="absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6"
    />
  </div>
</div>

  
    <div className="flex justify-between mb-4">
      <p className="font-semibold pl-4 text-[#87909A]">Customer Name</p>
      <p className="font-semibold text-[#87909A]">Customer ID</p>
      <p className="font-semibold text-left text-[#87909A]">Action</p>
    </div>
  
    <div className="container mx-auto">
      {currentCustomers.length > 0 ? (
        currentCustomers.map((customer, index) => (
          <div
            key={customer._id}
            className={`bg-white shadow-md rounded-lg p-4 mb-4 transition-all duration-300 ease-in-out transform ${
              index % 2 === 0 ? "bg-gray-50" : "bg-white"
            } group hover:bg-gray-100 hover:scale-[1.02] hover:shadow-lg hover:cursor-pointer`}
          >
            <div className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 items-center">
                <div className="flex items-center space-x-3">
                  <div className="w-7 h-7 bg-[#1C50A3] text-white rounded-full flex items-center justify-center font-bold group-hover:bg-blue-600">
                    {getFirstLetter(customer.customerName)}
                  </div>
                  <p className="text-[#292D32] font-semibold group-hover:text-blue-600">
                    {customer.customerName}
                  </p>
                </div>
                <p className="text-[#292D32] pl-20 font-semibold group-hover:text-blue-600">
                  {customer.customerId}
                </p>
                <div className="ml-auto text-right">
                  <button
                    onClick={() => handleView(customer.customerId)}
                    className="text-[#1C50A3] bg-[#E8F1FF] rounded-lg px-4 py-1 flex items-center space-x-2 transition duration-300"
                  >
                    <i className="fas fa-eye text-sm"></i>
                    <span className="font-semibold">View</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <p>No customers available</p>
      )}
    </div>
  
    <div className="flex justify-center items-center mt-6 space-x-3">
      <button
        onClick={goToPreviousPage}
        disabled={currentPage === 1}
        className="px-4 py-2 mx-1 rounded-md disabled:opacity-50 text-gray-600 text-sm font-semibold flex items-center"
      >
        <FontAwesomeIcon icon={faChevronLeft} className="mr-2" /> Previous
      </button>
  
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i + 1}
          onClick={() => handlePageChange(i + 1)}
          className={`px-3 py-1 mx-1 rounded-md text-sm font-semibold ${
            currentPage === i + 1
              ? "bg-[#1C50A3] text-white"
              : "bg-gray-200 text-gray-600"
          }`}
        >
          {i + 1}
        </button>
      ))}
  
      <button
        onClick={goToNextPage}
        disabled={currentPage === totalPages}
        className="px-4 py-2 mx-1 rounded-md disabled:opacity-50 text-gray-600 text-sm font-semibold flex items-center"
      >
        Next <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
      </button>
    </div>
    
      {/* Modal for displaying details */}
      <Modal
        isOpen={isDetailsModalOpen}
        onClose={() => setIsDetailsModalOpen(false)}
      >
        {selectedCustomerDetails && (
          <>
            <CustomerDetails details={selectedCustomerDetails} />
          

            <ProductTable
              records={selectedCustomerRecords}
              selectedProductIds={selectedProductIds}
              onApprove={handleApprove}
              onReject={handleReject}
              onViewInvoice={viewInvoice}
            />
          </>
        )}
      </Modal>

      {/* Confirmation Modals */}
      {showApproveModal && (
        <ConfirmationModal
          title="Confirm Approval"
          message={`Are you ready to approve the warranty for Customer ID: ${selectedCustomerId}?`}
          items={selectedProductIds.map((id) => {
            const product = selectedCustomerRecords.find(
              (record) => record._id === id
            );
            return product ? product.productID : null;
          })}
          onConfirm={confirmApprove}
          onCancel={cancelApprove}
          onFileUpload={true}
        />
      )}

      {statusCheckMessage && (
        <ConfirmationModal
          title="Status Check"
          message={statusCheckMessage}
          items={[]}
          onConfirm={() => setStatusCheckMessage("")}
          onCancel={() => setStatusCheckMessage("")}
          viewOnly={true}
        />
      )}

      {showRejectModal && (
        <ConfirmationModal
          title="Confirmation"
          message={`Are you sure you want to reject the selected warranties for Customer ID: ${selectedCustomerId}?`}
          items={selectedProductIds.map((id) => {
            const product = selectedCustomerRecords.find(
              (record) => record._id === id
            );
            return product ? product.productID : null;
          })}
          onConfirm={confirmReject}
          onCancel={cancelReject}
        />
      )}
    </div>
  );
};

export default AdminViewWarrantyExtended;
